import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, model } from '@angular/core';

import { DsButtonBase } from '@frontend/ui/shared';

export const DS_BUTTON_SOCIAL_VARIANT_ARRAY = ['filled', 'outline'] as const;
export type DsButtonSocialVariant = (typeof DS_BUTTON_SOCIAL_VARIANT_ARRAY)[number];

export const DS_BUTTON_SOCIAL_APP_ARRAY = ['yahoo', 'paypal', 'mlife', 'entain', 'facebook', 'apple', 'google'] as const;
export type DsButtonSocialAppArray = (typeof DS_BUTTON_SOCIAL_APP_ARRAY)[number];

export const DS_BUTTON_SOCIAL_SIZES_ARRAY = ['small', 'medium', 'large'] as const;
export type DsButtonSocialSize = (typeof DS_BUTTON_SOCIAL_SIZES_ARRAY)[number];

@Component({
    selector: 'button[ds-button-social], a[ds-button-social]',
    standalone: true,
    template: ` <span class="ds-social-start-slot">
            <ng-content select="[slot=start]" />
        </span>
        <span class="ds-social-btn-text">
            <ng-content />
        </span>`,
    styleUrl: './button-social.component.scss',
    host: {
        'class': 'ds-button-social',
        '[class]': 'hostClass()',
        '[class.ds-btn-social-disabled]': 'disabled() ? true : null',
    },
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsButtonSocial extends DsButtonBase {
    public readonly size = model<DsButtonSocialSize>('large');
    public readonly variant = model<DsButtonSocialVariant>('filled');
    public readonly socialApp = model<DsButtonSocialAppArray>('apple');

    protected readonly hostClass = computed(() => `ds-btn-social-${this.variant()}-${this.socialApp()} ds-btn-social-${this.size()}`);
}
